import useMedicalCompleteLock from "./useMedicalCompleteLock";

export default function useProviderRecordEditable(proCliData) {
  const { isProviderRecordLocked } = useMedicalCompleteLock();
  return Boolean(proCliData?.canEdit) && !isProviderRecordLocked(proCliData);
}
